exports.install = function (Vue, toastr) {
  if (this.installed) {
    return
  }

  this.installed = true

  toastr.options = {
    'closeButton': true,
    'debug': false,
    'newestOnTop': false,
    'progressBar': false,
    'positionClass': 'toast-top-center',
    'preventDuplicates': false,
    'onclick': null,
    'showDuration': '300',
    'hideDuration': '1000',
    'timeOut': '2000',
    'extendedTimeOut': '1000',
    'showEasing': 'swing',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
  }
  Vue.toastr = toastr

  Object.defineProperty(Vue.prototype, '$toastr', {
    get: function get () { return toastr }
  })
}



// WEBPACK FOOTER //
// ./src/configs/toastr/plugin.js